export default "__VITE_ASSET__TApf8rQz__"